import { useLocation } from 'react-router-dom';

const fullScreenPathnames = ['/answer', '/fullscreen', '/template', '/edit/'];

export const useIsFullScreenLegacyPage = () => {
  const { pathname } = useLocation();

  return fullScreenPathnames.some((path) => pathname.includes(path));
};
